export default __webpack_public_path__ + "static/media/data1.dfd93391.jpeg";